import OrgNodeCategory from './orgNodeCategory/orgNodeCategory'
import Organization from './organization/organization';
import OrgAuthorityManagement from './organization/orgAuthorityManagement/orgAuthorityManagement';
import OrganizationFileImport from './organization/organizationFile/organizationFileImport';
import PositionManager from  './position/positionManager';
import PositionDetail from './position/positionEdit/positionDetail'
import PositionCategoryManager from './positionCategory/positionCategoryManager';
import PersonInfoDetail from './person/personInfoDetail/personInfoDetail';
import PersonManage from './person/personManage';
import PersonDetail from './person/personDetail';
import ImportTemporary from './person/importTemporary';
import ImportGetPersonInfo from './person/importGetPersonInfo'
import ImportSchoolCooperationPerson from './person/importSchoolCooperationPerson';
import AdministrationScope from './person/administrationScope/administrationScope'
import PersonFaceAuthDetail from "./person/personFaceAuth/personFaceAuthDetail";
import UserMerge from "./person/userMerge/userMerge";
import TemporaryAccountRelation from "./temporaryAccountRelation/temporaryAccountRelation";
// import AddPerson from './person/addPerson/addPerson';
import DealerManager from './dealer/dealerManager';
import DealerAppealManager from './dealerAppeal/dealerAppealManager';
import LookDealerAppeal from './dealerAppeal/lookDealerAppeal'
import VinImport from './dealerAppeal/vinImport'
import DealerDetail from './dealer/dealerEdit/dealerDetail';
import DealerInfoDetail from './dealer/dealerInfoDetail/dealerInfoDetail';
import DealerUnionManager from './dealerUnion/dealerUnionManager';
import DealerUnionFileImport from './dealerUnion/dealerUnionFile/dealerUnionFileImport';
import AbilityAssess from './abilityAssess/index'
import OrganizationZoneCode from './zoneCode/zoneCodeManager';
import OrganizationZoneCodeDetail from './zoneCode/OrganizationZoneCodeDetail';
import BizDataMove from './bizDataMove/manager';
import BizDataMoveBiz from './bizDataMove/bizManager';
import BizDataMoveRecord from './bizDataMove/recordManager';
import BizDataMoveReplaceStudent from './bizDataMove/replaceStudent';
import BizDataMoveReplaceManager from './bizDataMove/replaceManager';
import BizDataMoveAddStudent from './bizDataMove/addStudent';
import BizDataMoveAddManager from './bizDataMove/addManager';
import BizDataMoveDeleteStudent from './bizDataMove/deleteStudent';
import BizDataMoveDeleteManager from './bizDataMove/deleteManager';
import AuthLoginLog from './authLoginLog/manager';
import AuthLoginLogDetail from './authLoginLog/detailManager';

export {
  OrgNodeCategory,
  OrganizationFileImport,
  Organization,
  PositionManager,
  PositionDetail,
  PositionCategoryManager,
  OrgAuthorityManagement,
  PersonInfoDetail,
  PersonManage,
  DealerInfoDetail,
  PersonDetail,
  // AddPerson,
  DealerManager,
  DealerDetail,
  DealerUnionManager,
  AdministrationScope,
  DealerUnionFileImport,
  AbilityAssess,
  ImportTemporary,
  OrganizationZoneCode,
  OrganizationZoneCodeDetail,
  ImportSchoolCooperationPerson,
  PersonFaceAuthDetail,
  BizDataMove,
  BizDataMoveBiz,
  BizDataMoveRecord,
  BizDataMoveReplaceStudent,
  BizDataMoveReplaceManager,
  BizDataMoveAddStudent,
  BizDataMoveAddManager,
  BizDataMoveDeleteStudent,
  BizDataMoveDeleteManager,
  AuthLoginLog,
  AuthLoginLogDetail,
  UserMerge,
  TemporaryAccountRelation,
  ImportGetPersonInfo,
  DealerAppealManager,
  LookDealerAppeal,
  VinImport
}
